import moment from 'moment-timezone';
import TIMEZONES from '@shared/constants/timezones';

// Fuseau par défaut d'une classe virtuelle (aligné sur Talkizy).
export const DEFAULT_MEETING_TIMEZONE = 'Europe/Paris';

/**
 * Options du <select> de fuseau, avec l'offset recalculé à la date de référence
 * (les libellés statiques portent l'offset d'hiver, faux la moitié de l'année
 * pour les zones à heure d'été). Le fuseau courant est ajouté s'il manque.
 */
export function timezoneSelectOptions(currentTimezone, referenceDate) {
  let options = TIMEZONES;

  if (currentTimezone && !options.some((tz) => tz.value === currentTimezone)) {
    options = [{ value: currentTimezone, label: currentTimezone }, ...options];
  }

  const reference = referenceDate || new Date();

  return options.map((tz) => {
    const offset = moment.tz(reference, tz.value).format('Z');
    const city = tz.label.replace(/^\(UTC[+-]\d{2}:\d{2}\)\s*/, '');
    return { value: tz.value, label: `(UTC${offset}) ${city}` };
  });
}

/**
 * La date/heure saisie dans le picker est une roue locale au navigateur ; on la
 * réinterprète dans le fuseau choisi (« 14:00 dans ce fuseau ») puis on la
 * convertit en instant absolu (ISO UTC) attendu par l'API Talkizy.
 */
export function wallClockToISO(dateObj, timezone) {
  if (!dateObj) return null;
  const wall = moment(dateObj).format('YYYY-MM-DD HH:mm:ss');
  return moment.tz(wall, timezone || DEFAULT_MEETING_TIMEZONE).toISOString();
}

/**
 * Inverse : depuis un instant absolu (ISO) et le fuseau de la classe, produit un
 * Date dont la roue locale du navigateur affiche l'heure DU FUSEAU, pour que le
 * picker montre bien l'heure de la classe (et non celle du navigateur).
 */
export function isoToWallClockDate(iso, timezone) {
  if (!iso) return null;
  const wall = moment.utc(iso).tz(timezone || DEFAULT_MEETING_TIMEZONE).format('YYYY-MM-DD HH:mm:ss');
  return moment(wall, 'YYYY-MM-DD HH:mm:ss').toDate();
}

/**
 * Instant absolu (ms) de la date saisie réinterprétée dans le fuseau choisi :
 * sert à valider « au moins N minutes à l'avance » quel que soit le fuseau.
 */
export function wallClockInstantMs(dateObj, timezone) {
  if (!dateObj) return null;
  return moment.tz(moment(dateObj).format('YYYY-MM-DD HH:mm:ss'), timezone || DEFAULT_MEETING_TIMEZONE).valueOf();
}
